import Checkbox from "@mui/material/Checkbox";
import React from "react";

// Utilisation d'un composant générique pour éviter la répétition
const ColoredRadio = ({ color, ...props }: { color: string }) => (
  <Checkbox
    color="default"
    sx={{
      color: color,
      '&.Mui-checked': {
        color: color,
      },
    }}
    {...props}
  />
);

export const GreenRadio = (props: any) => <ColoredRadio color="#76D19B" {...props} />;
export const RedRadio = (props: any) => <ColoredRadio color="#FE3123" {...props} />;
export const YellowRadio = (props: any) => <ColoredRadio color="#FFBF66" {...props} />;
export const BlueRadio = (props: any) => <ColoredRadio color="#008BD2" {...props} />;
export const GreyRadio = (props: any) => <ColoredRadio color="#E9E9E9" {...props} />;
export const BlackRadio = (props: any) => <ColoredRadio color="#000000" {...props} />;